<script>
import { mapState, mapGetters } from 'vuex'
import errorHandling from '../mixins/errorHandling'
import BuyCredits from './BuyCredits'

export default {
  components: {
    'buy-credits': BuyCredits
  },
  name: 'DashBanner',
  mixins: [errorHandling],
  data () {
    return {
      showModal: () => {}
    }
  },
  computed: {
    ...mapState([
      'user'
    ]),
    ...mapGetters({
      subscription: 'user/subscriptionExpiration'
    })
  },
  created () {
    if (!this.user.loaded) {
      this.$store.dispatch('user/loadUser')
        .then()
        .catch((err) => {
          this.errorHandling(err, () => {
            this.$store.dispatch('user/loadUser')
          })
        })
    }
  }
}
</script>

<template>
  <div class="a3d banner valign-wrapper"
       :class="{'govcloud': user.isGovcloudUser}"
       style="padding: 0 5em;justify-content: space-between;position:relative;">
    <template v-if='!user.loaded'>
      <div class="preloader-wrapper small active">
        <div class="spinner-layer">
          <div class="circle-clipper left">
            <div class="circle"></div>
          </div>
          <div class="gap-patch">
            <div class="circle"></div>
          </div>
          <div class="circle-clipper right">
            <div class="circle"></div>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="subscription-block">
        <div v-if='subscription' style='font-size: 1.2em;'>
          You have unlimited credits until <span style='font-weight:bold;'>{{subscription}}</span>
        </div>
        <div v-if='!subscription && user.credits.length === 0' style="font-size: 0.8em;">
          To submit a job, you need to buy a subscription.
        </div>
        <div v-if='!subscription && user.credits.length > 0' style="font-size: 0.8em;">
          You can submit one job per credit.
        </div>
      </div>
      <div class="govcloud-secure" v-if="user.isGovcloudUser && subscription">
        Secure GovCloud
      </div>
      <div v-if='!subscription' class="valign-wrapper" style="position:absolute;top:0;right:0;bottom:0;left:0;text-align:center;">
        <div style="flex-direction: column;margin:auto;font-weight:bold;">
          <div style="font-size: 3.5em;line-height:1;"> {{ user.credits.length }} </div>
          <div>credits</div>
        </div>
      </div>
      <div v-if='!subscription' style="display:flex;flex-direction:column;z-index: 1;font-size:0.8em;text-align:right;font-weight:bold;">
        <buy-credits :showModal.sync="showModal">
          <a class="a3d btn inv dark" slot='display' slot-scope='props' @click='props.open'>
            + Buy Subscription
          </a>
        </buy-credits>
        <div class="govcloud-secure" v-if="user.isGovcloudUser">
          Secure GovCloud
        </div>
      </div>
    </template>
  </div>
</template>
<style lang='scss' scoped>
  .banner {
    background-color: $atlas-blue;
    height:120px;
    width:100%;
    transition: background-color .3s;

    .btn.inv.dark {
      width:100%;
      font-size: inherit;
      padding:0.5em;
      line-height:1;
      height:auto;
    }

    &.govcloud {
      background-color: $atlas-govcloud;
      color: #ffffff;

      .btn.inv.dark {
        color: #ffffff;
        border-color: #ffffff;

        &:hover {
          background-color: $atlas-govcloud-seconary;
        }
      }

      .govcloud-secure {
        padding-top: 8px;
        font-size: 16px;
        font-weight: bold;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// Banner.vue?78b25cce